/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Cta_TitleInputs */

const en_nfp_cta_title = /** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to unify your community?`)
};

const es_nfp_cta_title = /** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Listo para unificar tu comunidad?`)
};

const fr_nfp_cta_title = /** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt à unifier votre communauté ?`)
};

const de_nfp_cta_title = /** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit, deine Gemeinschaft zu vereinen?`)
};

const id_nfp_cta_title = /** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap untuk menyatukan komunitas Anda?`)
};

/** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */
const ja_nfp_cta_title = en_nfp_cta_title;

/** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */
const zh_nfp_cta_title = en_nfp_cta_title;

/** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */
const ar_nfp_cta_title = en_nfp_cta_title;

/** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */
const it_nfp_cta_title = en_nfp_cta_title;

/** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */
const ru_nfp_cta_title = en_nfp_cta_title;

/** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */
const pt_nfp_cta_title = en_nfp_cta_title;

/** @type {(inputs: Nfp_Cta_TitleInputs) => LocalizedString} */
const ko_nfp_cta_title = en_nfp_cta_title;

/**
* | output |
* | --- |
* | "Ready to unify your community?" |
*
* @param {Nfp_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_cta_title = /** @type {((inputs?: Nfp_Cta_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Cta_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_cta_title(inputs)
	if (locale === "es") return es_nfp_cta_title(inputs)
	if (locale === "fr") return fr_nfp_cta_title(inputs)
	if (locale === "de") return de_nfp_cta_title(inputs)
	if (locale === "ja") return ja_nfp_cta_title(inputs)
	if (locale === "zh") return zh_nfp_cta_title(inputs)
	if (locale === "ar") return ar_nfp_cta_title(inputs)
	if (locale === "id") return id_nfp_cta_title(inputs)
	if (locale === "it") return it_nfp_cta_title(inputs)
	if (locale === "ru") return ru_nfp_cta_title(inputs)
	if (locale === "pt") return pt_nfp_cta_title(inputs)
	return ko_nfp_cta_title(inputs)
});